(function(){
  /* Active les animations d'apparition (fallback : tout reste visible si JS absent) */
  document.documentElement.classList.add('cv-anim');

  /* ---------------------------------------------------------------
     Ajout au panier via un vrai formulaire POST vers /cart/add.
     L'ancienne version faisait fetch('/cart/add.js') puis redirigeait
     immediatement : la page etait detruite avant que l'evenement
     analytics « ajoute au panier » ait le temps d'etre transmis,
     d'ou un total de 0 dans les rapports Shopify.
     Le POST est traite cote serveur, donc toujours comptabilise,
     et return_to renvoie le client vers la page panier.

     Note : les sections utilisent desormais des formulaires ecrits
     directement dans le HTML. Ce gestionnaire reste en place comme
     filet de securite pour d'eventuels boutons .cv-checkout-btn.
  --------------------------------------------------------------- */
  function cvHidden(form, name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  function cvCheckout(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    btn.disabled = true;
    btn.textContent = 'En cours...';

    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/cart/add';
    form.style.display = 'none';
    cvHidden(form, 'form_type', 'product');
    cvHidden(form, 'utf8', '✓');
    cvHidden(form, 'id', variantId);
    cvHidden(form, 'quantity', '1');
    cvHidden(form, 'return_to', '/cart');
    document.body.appendChild(form);
    form.submit();
  }

  function initButtons() {
    document.querySelectorAll('.cv-checkout-btn').forEach(function(btn) {
      if (!btn.dataset.cvInit) {
        btn.dataset.cvInit = '1';
        btn.addEventListener('click', function() { cvCheckout(btn); });
      }
    });
  }

  function initGallery() {
    var thumbs = document.querySelectorAll('.cv-product__thumb');
    var main = document.getElementById('cv-main-img');
    if (main) {
      thumbs.forEach(function(t){
        t.addEventListener('click', function(){
          thumbs.forEach(function(x){ x.classList.remove('is-active'); });
          t.classList.add('is-active');
          main.style.opacity = '0';
          setTimeout(function(){ main.src = t.dataset.full; main.style.opacity = '1'; }, 220);
        });
      });
    }
  }

  function initReveal() {
    var els = document.querySelectorAll('.cv-reveal');
    if (!els.length) return;

    function revealAll() {
      els.forEach(function(el) { el.classList.add('cv-revealed'); });
    }

    if (!('IntersectionObserver' in window)) { revealAll(); return; }

    /* threshold 0 : des qu'une portion entre dans l'ecran.
       Indispensable pour les blocs plus hauts que la fenetre (articles longs),
       qui n'atteignaient jamais un ratio de visibilite eleve. */
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('cv-revealed'); io.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function(el) { io.observe(el); });

    /* Filet de securite : rien ne doit rester invisible */
    setTimeout(revealAll, 2500);
  }

  /* Hauteur du header exposee en variable CSS (utilisee par le hero mobile) */
  function setHeaderVar() {
    var h = document.getElementById('cv-header');
    if (h) document.documentElement.style.setProperty('--cv-header-h', h.offsetHeight + 'px');
  }

  function init() {
    initButtons();
    initGallery();
    initReveal();
    setHeaderVar();
    window.addEventListener('resize', setHeaderVar, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
